import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { createStructuredSelector } from 'reselect';

import { Translate } from '@decorators';

import { IMainProps } from './types';

import * as s from './Main.scss';

@Translate('common.containers.Main')
export class MainBaseContainer extends React.Component<IMainProps> {

	render() {
		return (
			<div className={s.block}>
				<h1>{this.t('itWorks')}</h1>
			</div>
		);
	}

}

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators(
		{},
		dispatch,
	),
});

export const MainBase = connect(mapStateToProps, mapDispatchToProps)(MainBaseContainer);
